$(function () {
    $(window).on('load windowResizeBreakpointChanged', function () {
        makeDotdotdot(
            (currentWidth > screenSmMaxWidth ? 90 : 70),
            $('.equipment-container .item-header h3'),
            '.equipment-item-block',
            'letter',
            false
        );
    });

    $('.item-popup-section').hover(
        function (e) {
            //console.log('in');
            var $this = $(this);
            $this.addClass('active');
        },
        function (e) {
            //console.log('out');
            var $this = $(this);
            $this.removeClass('active');
        }
    );

    if (!!('ontouchstart' in window)) { //check for touch device
        $('.item-popup-section').unbind('click mouseenter mouseleave'); //use off if you used on, to unbind usual listeners
        $('.item-popup-section').on('click', function(event) {
            //console.log('click');
            var $this = $(this);
            if ($this.hasClass('active')) {
                $this.removeClass('active');

            } else {
                $this.addClass('active');
                event.stopPropagation();
                $('body').one('click', function(){
                    $('.item-popup-section.active').removeClass('active');
                });
            }
        });
    }

    $('.item-bottom-toggler').click(function (e) {
        e.preventDefault();

        var height = $(this).hasClass('active') ? 0 : 'auto';

        $(this).toggleClass('active');
        $(this).next().css({height: height});
    });

    $('.item-image').click(function (e) {
        e.preventDefault();

        var body = $('body');

        var $equipmentItemBlock = $(e.target).parents('.equipment-item-block');
        var equipmentItemCategoryName = $equipmentItemBlock.attr('data-category-name');
        var equipmentItemName = $equipmentItemBlock.attr('data-name');
        var equipmentItemImageUrl = $equipmentItemBlock.attr('data-image-url');

        var currentEquipmentItemIndex = $equipmentItemBlock.index();

        var equipmentItemsCount = $equipmentItemBlock.parent().find('.equipment-item-block').length;

        var modalTemplate =
            '<div id="dialog-modal-image-viewer" class="modal fade fade" tabindex="-1" role="dialog" aria-hidden="true">' +
                '<div class="modal-dialog">' +
                    '<div class="modal-content">' +
                        '<div class="modal-header">' +
                            '<div class="equipment-item-name-block">' +
                                '<span class="equipment-item-category-name-label">' + equipmentItemCategoryName + '</span>' +
                                ' - ' +
                                '<span class="equipment-item-name-label">' + equipmentItemName + '</span>' +
                            '</div>' +
                            '<a href="#" class="close-link" data-dismiss="modal" aria-hidden="true">' +
                                '<span class="close-label">close</span>' +
                                '<span class="close-icon icon-cancel-circled2"></span>' +
                            '</a>' +
                        '</div>' +
                        '<div class="modal-body">' +
                            '<div class="image-wrapper-block">' +
                                '<img src="' + equipmentItemImageUrl + '" class="equipment-item-image">' +
                                '<i class="icon-angle-left"></i>' +
                                '<i class="icon-angle-right"></i>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                '</div>' +
            '</div>';

        body.append($(modalTemplate));

        $('#dialog-modal-image-viewer').modal({
            backdrop: true
            //backdrop: false
            //backdrop: 'static'
        });

        body.one('shown.bs.modal', '#dialog-modal-image-viewer', function () {
            $('#dialog-modal-image-viewer .image-wrapper-block .icon-angle-left').click(function (e) {
                e.preventDefault();

                currentEquipmentItemIndex--;
                if (currentEquipmentItemIndex < 0) {
                    currentEquipmentItemIndex = equipmentItemsCount - 1;
                }

                $equipmentItemBlock = $equipmentItemBlock.parent().children().eq(currentEquipmentItemIndex);

                var equipmentItemName = $equipmentItemBlock.attr('data-name');
                var equipmentItemImageUrl = $equipmentItemBlock.attr('data-image-url');

                $('#dialog-modal-image-viewer .equipment-item-name-label').html(equipmentItemName);
                $('#dialog-modal-image-viewer .equipment-item-image').attr('src', equipmentItemImageUrl);
            });

            $('#dialog-modal-image-viewer .image-wrapper-block .icon-angle-right').click(function (e) {
                e.preventDefault();

                currentEquipmentItemIndex++;
                if (currentEquipmentItemIndex == equipmentItemsCount) {
                    currentEquipmentItemIndex = 0;
                }

                $equipmentItemBlock = $equipmentItemBlock.parent().children().eq(currentEquipmentItemIndex);

                var equipmentItemName = $equipmentItemBlock.attr('data-name');
                var equipmentItemImageUrl = $equipmentItemBlock.attr('data-image-url');

                $('#dialog-modal-image-viewer .equipment-item-name-label').html(equipmentItemName);
                $('#dialog-modal-image-viewer .equipment-item-image').attr('src', equipmentItemImageUrl);
            });
        });

        body.one('hidden.bs.modal', '#dialog-modal-image-viewer', function () {
            $('#dialog-modal-image-viewer').remove();
            $(this).removeData('bs.modal');
        });
    });
});